import { useEffect, Fragment, useRef, useState } from "react";
import { Link, useLocation, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCourseDetail } from "../action";
import Wizard from "@components/wizard";
import "@styles/base/pages/app-ecommerce-details.scss";
import BreadCrumbs from "@components/breadcrumbs";
import { FileText, CreditCard, Trash2, ArrowLeft } from "react-feather";
import Payment from "./Payment";
import PaymentProof from "./proof";
import PaymentReceipt from "./receipt";

const Details = () => {
  const location = useLocation();
  const { courseId, transactionCourseUserId } = location.state || {};

  if (!transactionCourseUserId) return <Redirect to="/payment" />;
  const [stepper, setStepper] = useState(null);
  const ref = useRef(null);
  const dispatch = useDispatch();
  const payment = useSelector((state) => state.payment);
  const [
    transactionCourseUserAddress,
    setTransactionCourseUserAddress,
  ] = useState(payment.transactionCourseUserAddress);

  const [receiptDate, setReceiptDate] = useState(
    transactionCourseUserAddress && transactionCourseUserAddress.receiptDate
      ? new Date(transactionCourseUserAddress.receiptDate)
      : null
  );
  const [address1, setAddress1] = useState(
    transactionCourseUserAddress && transactionCourseUserAddress.address1
      ? transactionCourseUserAddress.address1
      : null
  );

  const [address2, setAddress2] = useState(
    transactionCourseUserAddress && transactionCourseUserAddress.address2
      ? transactionCourseUserAddress.address2
      : null
  );

  const [receiptNameFlag, setReceiptNameFlag] = useState(
      transactionCourseUserAddress && transactionCourseUserAddress.receiptNameFlag
          ? transactionCourseUserAddress.receiptNameFlag
          : null
  );

  useEffect(() => {
    dispatch(
      getCourseDetail({
        transactionCourseUserId: transactionCourseUserId,
      })
    );
  }, []);

  const steps = [
    {
      id: "payment-details",
      title: "ข้อมูลการชำระเงิน",
      subtitle: "",
      icon: <FileText size={18} />,
      content: (
        <Payment
          data={payment.courseDetail}
          payment={payment}
          transactionCourseUser={payment.transactionCourseUser}
          transactionPaymentProofs={payment.transactionPaymentProofs}
          getCourseDetail={getCourseDetail}
          courseId={courseId}
          transactionCourseUserId={transactionCourseUserId}
          dispatch={dispatch}
          stepper={stepper}
        />
      ),
    },
    {
      id: "proof-details",
      title: "หลักฐานการชำระเงิน",
      subtitle: "",
      icon: <FileText size={18} />,
      content: (
        <PaymentProof
          data={payment.courseDetail}
          payment={payment}
          transactionCourseUser={payment.transactionCourseUser}
          transactionPaymentProofs={payment.transactionPaymentProofs}
          transactionCourseUserAddress={payment.transactionCourseUserAddress}
          getCourseDetail={getCourseDetail}
          courseId={courseId}
          transactionCourseUserId={transactionCourseUserId}
          dispatch={dispatch}
          stepper={stepper}
          receiptDate={receiptDate}
          setReceiptDate={setReceiptDate}
          address1={address1}
          setAddress1={setAddress1}
          address2={address2}
          setAddress2={setAddress2}
          receiptNameFlag={receiptNameFlag}
          setReceiptNameFlag={setReceiptNameFlag}
        />
      ),
    },
    {
      id: "receipt-details",
      title: "ข้อมูลใบเสร็จ",
      subtitle: "",
      icon: <FileText size={18} />,
      content: (
        <PaymentReceipt
          data={payment.courseDetail}
          payment={payment}
          transactionCourseUser={payment.transactionCourseUser}
          transactionPaymentProofs={payment.transactionPaymentProofs}
          transactionCourseUserAddress={payment.transactionCourseUserAddress}
          getCourseDetail={getCourseDetail}
          courseId={courseId}
          transactionCourseUserId={transactionCourseUserId}
          dispatch={dispatch}
          stepper={stepper}
          receiptDate={receiptDate}
          setReceiptDate={setReceiptDate}
          address1={address1}
          setAddress1={setAddress1}
          address2={address2}
          setAddress2={setAddress2}
          receiptNameFlag={receiptNameFlag}
          setReceiptNameFlag={setReceiptNameFlag}
        />
      ),
    },
  ];

  const steps2 = [
    {
      id: "proof-details",
      title: "หลักฐานการชำระเงิน",
      subtitle: "",
      icon: <FileText size={18} />,
      content: (
        <PaymentProof
          data={payment.courseDetail}
          payment={payment}
          transactionCourseUser={payment.transactionCourseUser}
          transactionPaymentProofs={payment.transactionPaymentProofs}
          transactionCourseUserAddress={payment.transactionCourseUserAddress}
          getCourseDetail={getCourseDetail}
          courseId={courseId}
          transactionCourseUserId={transactionCourseUserId}
          dispatch={dispatch}
          stepper={stepper}
          receiptDate={receiptDate}
          setReceiptDate={setReceiptDate}
          address1={address1}
          setAddress1={setAddress1}
          address2={address2}
          setAddress2={setAddress2}
          receiptNameFlag={receiptNameFlag}
          setReceiptNameFlag={setReceiptNameFlag}
        />
      ),
    },
    {
      id: "receipt-details",
      title: "ข้อมูลใบเสร็จ",
      subtitle: "",
      icon: <FileText size={18} />,
      content: (
        <PaymentReceipt
          data={payment.courseDetail}
          payment={payment}
          transactionCourseUser={payment.transactionCourseUser}
          transactionPaymentProofs={payment.transactionPaymentProofs}
          transactionCourseUserAddress={payment.transactionCourseUserAddress}
          getCourseDetail={getCourseDetail}
          courseId={courseId}
          transactionCourseUserId={transactionCourseUserId}
          dispatch={dispatch}
          stepper={stepper}
          receiptDate={receiptDate}
          setReceiptDate={setReceiptDate}
          address1={address1}
          setAddress1={setAddress1}
          address2={address2}
          setAddress2={setAddress2}
          receiptNameFlag={receiptNameFlag}
          setReceiptNameFlag={setReceiptNameFlag}
        />
      ),
    },
  ];

  const steps3 = [
    {
      id: "proof-details",
      title: "หลักฐานการชำระเงิน",
      subtitle: "",
      icon: <FileText size={18} />,
      content: (
        <PaymentProof
          data={payment.courseDetail}
          payment={payment}
          transactionCourseUser={payment.transactionCourseUser}
          transactionPaymentProofs={payment.transactionPaymentProofs}
          transactionCourseUserAddress={payment.transactionCourseUserAddress}
          getCourseDetail={getCourseDetail}
          courseId={courseId}
          transactionCourseUserId={transactionCourseUserId}
          dispatch={dispatch}
          stepper={stepper}
          receiptDate={receiptDate}
          setReceiptDate={setReceiptDate}
          address1={address1}
          setAddress1={setAddress1}
          address2={address2}
          setAddress2={setAddress2}
          receiptNameFlag={receiptNameFlag}
          setReceiptNameFlag={setReceiptNameFlag}
        />
      ),
    },
  ];

  return (
    <Fragment>
      <BreadCrumbs
        breadCrumbTitle="รายละเอียดการชำระเงิน"
        breadCrumbParent="ชำระค่าลงทะเบียน"
        breadCrumbActive="รายละเอียดการชำระเงิน"
      />
      <div className="app-ecommerce-details">
        <div className="modern-horizontal-wizard">
          {payment.courseDetail && Object.keys(payment.courseDetail).length ? (
            payment &&
            payment.transactionCourseUser &&
            (payment.transactionCourseUser.status === "PAYMENT_SUCCESS" ||
              payment.transactionCourseUser.status === "WAIT_ADMIN_APPROVE") ? (
              <Wizard
                type="modern-horizontal"
                ref={ref}
                steps={steps2}
                instance={(el) => setStepper(el)}
              />
            ) : null
          ) : null}
          {payment.courseDetail && Object.keys(payment.courseDetail).length ? (
            payment &&
            payment.transactionCourseUser &&
            payment.transactionCourseUser.status !== "PAYMENT_SUCCESS" &&
            payment.transactionCourseUser.status !== "APPROVE_SUCCESS" &&
            payment.transactionCourseUser.status !== "CANCEL" &&
            payment.transactionCourseUser.status !== "WAIT_ADMIN_APPROVE" ? (
              <Wizard
                type="modern-horizontal"
                ref={ref}
                steps={steps}
                instance={(el) => setStepper(el)}
              />
            ) : null
          ) : null}
          {payment.courseDetail && Object.keys(payment.courseDetail).length ? (
            payment &&
            payment.transactionCourseUser &&
            (payment.transactionCourseUser.status === "APPROVE_SUCCESS" ||
              payment.transactionCourseUser.status === "CANCEL") ? (
              <Wizard
                type="modern-horizontal"
                ref={ref}
                steps={steps3}
                instance={(el) => setStepper(el)}
              />
            ) : null
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};

export default Details;
